export default {
  calculator: {
    buyLabelName: 'маю',
    swapButtonAriaLabel: 'поміняти валюти місцями',
    sellLabelName: 'отримаю',
    currentRate: 'Поточний курс:',
    continueButton: 'Продовжити обмін',
    miniChart: 'Мініграфік показує коливання середнього курсу за останні 7 днів',
    sellTooltip:
      'Це курс продажу - ми продаємо Тобі {{currency}} за {{rate}} PLN. Чим нижчий курс, тим вигідніше для Тебе. Автоматичне оновлення кожні 10 секунд.',
    buyTooltip:
      'Це курс купівлі - ми купуємо у тебе {{currency}} за {{rate}} PLN. Чим вищий курс, тим вигідніше для Тебе. Автоматичне оновлення кожні 10 секунд.',
    saleNotAvailableInfo: 'Наразі продаж у {{baseCurrency}} недоступний',
    minAmount: 'Мінімальна сума обміну - {{minAmount}} {{minCurrency}}.',
  },
  creditCalculator: {
    monthlyLoan: 'Щомісячний платіж за кредитом',
    loanTerm: 'До кінця кредиту залишилося',
    whichBank: 'У якому банку Ти оплачуєш кредит?',
    save: 'Заощаджуй!',
    years: 'років',
    inYear: 'протягом року',
    toEnd: 'до кінця кредиту',
    installmentAmount: 'Сума платежу занадто мала',
  },
  INTERNAL:
    'Гроші надійдуть приблизно через 30 хвилин після отримання Твого переказу, найпізніше наступного робочого дня.',
  TODAY: 'Гроші надійдуть найпізніше наступного робочого дня.',
  TODAY_OUR: 'Гроші надійдуть найпізніше наступного робочого дня.',
  SEPA: 'Гроші надійдуть протягом 1 - 2 робочих днів.',
  SEPA_INSTANT: 'Гроші надійдуть приблизно за 1 хвилину.',
  SPOT: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
  ELIXIR: 'Гроші надійдуть найпізніше наступного робочого дня.',
  LOCAL: 'Гроші надійдуть найпізніше наступного робочого дня.',
  profitCalculator: {
    transferNotSupported: 'Обраний банк не підтримує перекази цієї валюти.',
    transferFree: 'Ми не стягуємо жодних комісій за відправлення обміняних коштів!',
    transferFee:
      'За переказ до обраного тобою банку стягується банківська комісія – {{transferFee}} PLN. Комісію вже враховано в розрахунку.',
  },
  preactSelect: {
    search: 'Пошук...',
  },
  newsletter: {
    alreadySubscribed: 'Твоя електронна адреса вже підписана на нашу розсилку.',
    error: 'Щось пішло не так. Спробуй пізніше.',
  },
  frontpageExitPopup: {
    accountExists: 'Схоже, у Тебе вже є обліковий запис. Знижку надсилаємо для нових клієнтів.',
    error: 'Виникла помилка',
  },
  emailValidator: {
    requiredField: 'Потрібно відмітити це поле',
    notEmptyField: 'Це поле не може бути порожнім',
    minValue: 'Мінімальне значення –',
    maxValue: 'Максимальне значення –',
    incorrectEmail: 'Введи правильну адресу електронної пошти',
    toShortPassword: 'Пароль занадто короткий',
  },
  currencyAlert: {
    isLower: 'буде нижчим',
    isHigher: 'буде вищим',
    mustBeLessThan: 'Курс має бути числом меншим за 99,9999',
    alertAlreadyExists: 'Сповіщення для цього курсу вже існує',
    maxAlerts: 'Ти не можеш підписатися на більшу кількість сповіщень (макс. 10)',
    error: 'Щось пішло не так, спробуй за мить.',
    alertHash: 'валютне-сповіщення',
    averageRateNotAvailable:
      'Зараз не можемо встановити сповіщення, оскільки курс {{currency}} тимчасово недоступний ({{averageRate}}).',
  },
  ratesUpdate: {
    update: 'Триває оновлення курсів...',
    success: 'Наступне оновлення курсу через',
    error: 'Не вдалося отримати дані. Повторюємо через',
  },
  currencyAnnotations: {
    notSupported: 'Обмін цієї валюти наразі недоступний',
  },
  currencies: {
    AED: 'Дирхам ОАЕ',
    ARS: 'Аргентинський песо',
    AUD: 'Австралійський долар',
    BDT: 'Бангладеська така',
    BGN: 'Болгарський лев',
    BRL: 'Бразильський реал',
    CAD: 'Канадський долар',
    CHF: 'Швейцарський франк',
    CLP: 'Чилійський песо',
    CNY: 'Китайський юань',
    COP: 'Колумбійський песо',
    CZK: 'Чеська крона',
    DKK: 'Данська крона',
    EGP: 'Єгипетський фунт',
    EUR: 'Євро',
    FJD: 'Фіджійський долар',
    GBP: 'Фунт стерлінгів',
    GHS: 'Ганський седі',
    HKD: 'Гонконгський долар',
    HUF: 'Угорський форинт',
    ILS: 'Ізраїльський новий шекель',
    INR: 'Індійська рупія',
    JOD: 'Йорданський динар',
    JPY: 'Японська єна',
    KWD: 'Кувейтський динар',
    LSL: 'Марокканський дирхам',
    MXN: 'Мексиканський песо',
    NOK: 'Норвезька крона',
    NPR: 'Непальська рупія',
    NZD: 'Новозеландський долар',
    OMR: 'Оманський ріал',
    PEN: 'Перуанський соль',
    PGK: 'Кіна',
    PLN: 'Польський злотий',
    RON: 'Румунський лей',
    RUB: 'Російський рубль',
    SAR: 'Саудівський ріал',
    SEK: 'Шведська крона',
    SGD: 'Сінгапурський долар',
    SZL: 'Свазілендський ліланґені',
    THB: 'Тайський бат',
    TRY: 'Турецька ліра',
    USD: 'Долар США',
    UYU: 'Уругвайський песо',
    WST: 'Самоанська тала',
    ZAR: 'Південноафриканський ранд',
  },
  currenciesDopelniacz: {
    AED: 'дирхама ОАЕ',
    ARS: 'аргентинського песо',
    AUD: 'австралійського долара',
    BDT: 'бангладеської таки',
    BGN: 'болгарського лева',
    BRL: 'бразильського реала',
    CAD: 'канадського долара',
    CHF: 'швейцарського франка',
    CNY: 'китайського юаня',
    CZK: 'чеської крони',
    DKK: 'данської крони',
    EGP: 'єгипетського фунта',
    EUR: 'євро',
    FJD: 'фіджійського долара',
    GBP: 'фунта стерлінгів',
    GHS: 'ганського седі',
    HKD: 'гонконгського долара',
    INR: 'індійської рупії',
    JOD: 'йорданського динара',
    KWD: 'кувейтського динара',
    LSL: 'лесотського лоті',
    MAD: 'марокканського дирхама',
    MXN: 'мексиканського песо',
    NOK: 'норвезької крони',
    NPR: 'непальської рупії',
    NZD: 'новозеландського долара',
    OMR: 'оманського ріала',
    PEN: 'перуанського соля',
    PGK: 'папуаської кіни',
    PLN: 'польського злотого',
    RON: 'румунського лея',
    RUB: 'російського рубля',
    SAR: 'саудівського ріала',
    SEK: 'шведської крони',
    SGD: 'сінгапурського долара',
    SZL: 'лілангені свазіленду',
    THB: 'тайського бата',
    TRY: 'турецької ліри',
    USD: 'долара США',
    UYU: 'уругвайського песо',
    WST: 'самоанської тали',
    ZAR: 'південноафриканського ранда',
  },
  chart: {
    time: 'Час',
    rate: 'Курс',
    opening: 'Відкриття',
    highest: 'Найвищий',
    lowest: 'Найнижчий',
    closing: 'Закриття',
    monthNames: ['січ', 'лют', 'бер', 'кві', 'тра', 'чер', 'лип', 'сер', 'вер', 'жов', 'лис', 'гру'],
    dayNames: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'нд'],
  },
  landingForm: {
    show: 'Показати',
    hide: 'Приховати',
    requiredField: 'Потрібно відмітити це поле',
    notEmptyField: 'Це поле не може бути порожнім',
    incorrectEmail: 'Введи правильну адресу електронної пошти',
    toShortPassword: 'Пароль занадто короткий',
    invalidPromocode: 'Акція на цій сторінці вже завершилися - зареєструйся через головну сторінку',
    emailAlreadyExists: 'Цю електронну адресу не можна використати для реєстрації',
    generalInvalid: 'Щось пішло не так, спробуй пізніше',
    competitionFormThanks: 'Дякуємо за участь у конкурсі!',
  },
  networkErrorStatus: {
    slow: 'Проблема із завантаженням курсів валют. Повільне інтернет-зʼєднання.',
    noNetwork: 'Проблема із завантаженням курсів валют. Перевір, чи є інтернет-зʼєднання.',
    default: 'Виникли технічні проблеми. Звернись до Відділу Обслуговування Клієнта.',
  },
  calculatorForegin: {
    continueButton: 'Продовжити обмін',
    exchangeRates: 'Курс обміну',
    details: 'Деталі',
    amountYouSend: 'Сума, яку я вношу',
    countryYouSendMoney: 'Країна, до якої Ти надсилаєш гроші',
    foreignTransferFee: 'Комісія за міжнародний переказ',
    foreignTransferType: 'Тип міжнародного переказу',
    exchangeAmount: 'Сума обміну',
    amountRecipientReceive: 'Сума, яку отримає одержувач',
    minAmount: 'Сума обміну занадто мала.',
    notSellCurrency: 'Продаж валюти недоступний.',
    transferTypes: {
      INTERNAL: {
        name: 'INTERNAL',
        desc: 'Гроші надійдуть приблизно через 30 хвилин після отримання Твого переказу, найпізніше наступного робочого дня.',
      },
      TODAY: {
        name: 'TODAY',
        desc: 'Гроші надійдуть найпізніше наступного робочого дня.',
      },
      TODAY_OUR: {
        name: 'TODAY OUR',
        desc: 'Гроші надійдуть найпізніше наступного робочого дня.',
      },
      SEPA: {
        name: 'SEPA',
        desc: 'Гроші надійдуть протягом 1 - 2 робочих днів.',
      },
      SEPA_INSTANT: {
        name: 'SEPA INSTANT',
        desc: 'Гроші надійдуть приблизно за 1 хвилину.',
      },
      SPOT: {
        name: 'SPOT',
        desc: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      },
      ELIXIR: {
        name: 'ELIXIR',
        desc: 'Гроші надійдуть найпізніше наступного робочого дня.',
      },
      LOCAL: {
        name: 'LOCAL',
        desc: 'Гроші надійдуть найпізніше наступного робочого дня.',
      },
    },
  },
  timer: {
    update: 'Оновлення через:',
    timeUnit: 'сек.',
  },
  countries: {
    AD: 'Андорра',
    AE: 'Обʼєднані Арабські Емірати',
    AF: 'Афганістан',
    AG: 'Антигуа і Барбуда',
    AI: 'Ангілья',
    AL: 'Албанія',
    AM: 'Вірменія',
    AN: 'Нідерландські Антильські острови',
    AO: 'Ангола',
    AQ: 'Антарктида',
    AR: 'Аргентина',
    AS: 'Американське Самоа',
    AT: 'Австрія',
    AU: 'Австралія',
    AW: 'Аруба',
    AX: 'Аландські острови',
    AZ: 'Азербайджан',
    BA: 'Боснія і Герцеговина',
    BB: 'Барбадос',
    BD: 'Бангладеш',
    BE: 'Бельгія',
    BF: 'Буркіна-Facо',
    BG: 'Болгарія',
    BH: 'Бахрейн',
    BI: 'Бурунді',
    BJ: 'Бенін',
    BL: 'Сен-Бартелемі',
    BM: 'Бермудські острови',
    BN: 'Бруней',
    BO: 'Болівія',
    BR: 'Бразилія',
    BS: 'Багамські острови',
    BT: 'Бутан',
    BV: 'Острів Буве',
    BW: 'Ботсвана',
    BY: 'Білорусь',
    BZ: 'Беліз',
    CA: 'Канада',
    CC: 'Кокосові (Кілінг) острови',
    CD: 'Демократична Республіка Конго',
    CF: 'Центральноафриканська Республіка',
    CG: 'Республика Конго',
    CH: 'Швейцарія',
    CI: 'Кот-дʼІвуар',
    CK: 'Острови Кука',
    CL: 'Чилі',
    CM: 'Камерун',
    CN: 'Китай',
    CO: 'Колумбія',
    CR: 'Коста-Рика',
    CU: 'Куба',
    CV: 'Кабо-Верде',
    CW: 'Кюрасао',
    CX: 'Острів Різдва',
    CY: 'Кіпр',
    CZ: 'Чехія',
    DE: 'Німеччина',
    DJ: 'Джибуті',
    DK: 'Данія',
    DM: 'Домініка',
    DO: 'Домініканська Республіка',
    DZ: 'Алжир',
    EC: 'Еквадор',
    EE: 'Естонія',
    EG: 'Єгипет',
    EH: 'Західна Сахара',
    ER: 'Еритрея',
    ES: 'Іспанія',
    ET: 'Ефіопія',
    FI: 'Фінляндія',
    FJ: 'Фіджі',
    FK: 'Фолклендські острови',
    FM: 'Федеративні Штати Мікронезії',
    FO: 'Фарерські острови',
    FR: 'Франція',
    GA: 'Габон',
    GB: 'Велика Британія',
    GD: 'Гренада',
    GE: 'Грузія',
    GF: 'Французька Гвіана',
    GG: 'Гернсі',
    GH: 'Гана',
    GI: 'Гібралтар',
    GL: 'Гренландія',
    GM: 'Гамбія',
    GN: 'Гвінея',
    GP: 'Гваделупа',
    GQ: 'Екваторіальна Гвінея',
    GR: 'Греція',
    GS: 'Південна Джорджія та Південні Сандвічеві острови',
    GT: 'Гватемала',
    GU: 'Гуам',
    GW: 'Гвінея-Бісау',
    GY: 'Гаяна',
    HK: 'Гонконг',
    HM: 'Острови Герд і Макдональд',
    HN: 'Гондурас',
    HR: 'Хорватія',
    HT: 'Гаїті',
    HU: 'Угорщина',
    ID: 'Індонезія',
    IE: 'Ірландія',
    IL: 'Ізраїль',
    IM: 'Острів Мен',
    IN: 'Індія',
    IO: 'Британська територія в Індійському океані',
    IQ: 'Ірак',
    IR: 'Іран',
    IS: 'Ісландія',
    IT: 'Італія',
    JE: 'Джерсі',
    JM: 'Ямайка',
    JO: 'Йорданія',
    JP: 'Японія',
    KE: 'Кенія',
    KG: 'Киргизстан',
    KH: 'Камбоджа',
    KI: 'Кірибаті',
    KM: 'Комори',
    KN: 'Сент-Кітс і Невіс',
    KP: 'КНДР',
    KR: 'Республіка Корея',
    KW: 'Кувейт',
    KY: 'Кайманові острови',
    KZ: 'Казахстан',
    LA: 'Лаос',
    LB: 'Ліван',
    LC: 'Сент-Люсія',
    LI: 'Ліхтенштейн',
    LK: 'Шрі-Ланка',
    LR: 'Ліберія',
    LS: 'Лесото',
    LT: 'Литва',
    LU: 'Люксембург',
    LV: 'Латвія',
    LY: 'Лівія',
    MA: 'Марокко',
    MC: 'Монако',
    MD: 'Молдова',
    ME: 'Чорногорія',
    MF: 'Сен-Мартен',
    MG: 'Мадагаскар',
    MH: 'Маршаллові Острови',
    MK: 'Північна Македонія',
    ML: 'Малі',
    MM: 'Мʼянма',
    MN: 'Монголія',
    MO: 'Макао',
    MP: 'Північні Маріанські острови',
    MQ: 'Мартиніка',
    MR: 'Мавританія',
    MS: 'Монтсеррат',
    MT: 'Мальта',
    MU: 'Маврикій',
    MV: 'Мальдіви',
    MW: 'Малаві',
    MX: 'Мексика',
    MY: 'Малайзія',
    MZ: 'Мозамбік',
    NA: 'Намібія',
    NC: 'Нова Каледонія',
    NE: 'Нігер',
    NF: 'Острів Норфолк',
    NG: 'Нігерія',
    NI: 'Нікарагуа',
    NL: 'Нідерланди',
    NO: 'Норвегія',
    NP: 'Непал',
    NR: 'Науру',
    NU: 'Ніуе',
    NZ: 'Нова Зеландія',
    OM: 'Оман',
    PA: 'Панама',
    PE: 'Перу',
    PF: 'Французька Полінезія',
    PG: 'Папуа-Нова Гвінея',
    PH: 'Філіппіни',
    PK: 'Пакистан',
    PL: 'Польща',
    PM: 'Сен-Пʼєр і Мікелон',
    PN: 'Піткерн',
    PR: 'Пуерто-Рико',
    PS: 'Палестина',
    PT: 'Португалія',
    PW: 'Палау',
    PY: 'Парагвай',
    QA: 'Катар',
    RE: 'Реюньйон',
    RO: 'Румунія',
    RS: 'Сербія',
    RU: 'Росія',
    RW: 'Руанда',
    SA: 'Саудівська Аравія',
    SB: 'Соломонові Острови',
    SC: 'Сейшельські Острови',
    SD: 'Судан',
    SE: 'Швеція',
    SGD: 'Сінгапур',
    SH: 'Острів Святої Єлени',
    SI: 'Словенія',
    SJ: 'Свальбард і Ян-Маєн',
    SK: 'Словаччина',
    SL: 'Сьєрра-Леоне',
    SM: 'Сан-Марино',
    SN: 'Сенегал',
    SO: 'Сомалі',
    SR: 'Суринам',
    ST: 'Сан-Томе і Принсіпі',
    SV: 'Сальвадор',
    SY: 'Сирія',
    SZ: 'Есватіні',
    TC: 'Теркс і Кайкос',
    TD: 'Чад',
    TF: 'Французькі Південні території',
    TG: 'Того',
    TH: 'Таїланд',
    TJ: 'Таджикистан',
    TK: 'Токелау',
    TL: 'Східний Тимор',
    TM: 'Туркменістан',
    TN: 'Туніс',
    TO: 'Тонга',
    TR: 'Туреччина',
    TT: 'Тринідад і Тобаго',
    TV: 'Тувалу',
    TW: 'Тайвань',
    TZ: 'Танзанія',
    UA: 'Україна',
    UG: 'Уганда',
    UM: 'Малі віддалені острови США',
    US: 'США',
    UY: 'Уругвай',
    UZ: 'Узбекистан',
    VA: 'Ватикан',
    VC: 'Сент-Вінсент і Гренадини',
    VE: 'Венесуела',
    VG: 'Британські Віргінські острови',
    VI: 'Американські Віргінські острови',
    VN: 'Вʼєтнам',
    VU: 'Вануату',
    WF: 'Волліс і Футуна',
    WS: 'Самоа',
    XK: 'Косово',
    YE: 'Ємен',
    YT: 'Майотта',
    ZA: 'Південно-Африканська Республіка',
    ZM: 'Замбія',
    ZW: 'Зімбабве',
  },
}
